// eslint-disable-next-line no-empty
const noop = () => {};

export { noop as n };
//# sourceMappingURL=noop-fc861ff1.js.map
